import { render } from "./MultiselectCheckboxItem.vue?vue&type=template&id=32f3eef5&scoped=true"
import script from "./MultiselectCheckboxItem.vue?vue&type=script&lang=js"
export * from "./MultiselectCheckboxItem.vue?vue&type=script&lang=js"

import "./MultiselectCheckboxItem.vue?vue&type=style&index=0&id=32f3eef5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f3eef5"]])

export default __exports__